<div class="spinner">
    <div></div>
</div>